// Single source of truth — the close-time reset rebuilds from this
// factory. Any field added here is automatically cleared on close.
const createInitialDonationWidgetState = () => ({
  // campaignId: '1',
  campaign: {},
  campaignId: '',
  pledgeId: '',
  amount: '7500', // in pennies
  otherAmountInView: false,
  // Seed to mirror the default $75 pill (amount 7500) so the custom-amount
  // box shows a solid, fully-opaque value on open instead of the faded
  // pink-200 placeholder. Pill clicks keep this in sync via updateDonationValue.
  enteredOtherAmount: '75',
  occurrence: 'once', // or 'monthly'
  isAnonymous: false,
  hasDedication: false,
  inHonorOfSelection: 'memory', // or honor
  honoreeName: '',
  honoreeEmail: '',
  honoreeMessage: '',
  doubleTheDonation: {},
  paymentToken: '',
  paymentIdentifier: '',

  firstName: '',
  lastName: '',
  businessName: '',
  email: '',
  city: '',
  state: '',
  zip: '',
  ccNumber: '',
  cvv: '',
  ccLast4: '',
  expMonth: '',
  expYear: '',

  isProcessing: false,
  paidForTransactionFee: false,
  calculatedTransactionFee: 0,
  donationId: '',
  steps: {
    donation: {
      isInView: true,
      isValid: false,
    },
    payment: {
      isInView: false,
      isValid: false,
    },
    employerMatch: {
      isInView: false,
      isValid: false,
    },
    contact: {
      isInView: false,
      isValid: false,
    },
    thankYou: {
      isInView: false,
      isValid: false,
    },
  },

  successfulTransactionData: {},
  pledge: null,
})

const state = {
  donationWidget: createInitialDonationWidgetState(),
}

const getters = {
  donationWidget: state => {
    return state.donationWidget
  },
}

const mutations = {
  addCampaignId: (state, campaignId) => {
    state.donationWidget.campaignId = campaignId
  },
  addPledgeId: (state, pledgeId) => {
    state.donationWidget.pledgeId = pledgeId
  },
  updateAmount: (state, amount) => {
    state.donationWidget.amount = amount
  },
  updateEnteredOtherAmount: (state, amount) => {
    state.donationWidget.enteredOtherAmount = amount
  },
  updateOtherAmountInView: (state, flag) => {
    state.donationWidget.otherAmountInView = flag
  },
  updateCampaign: (state, campaign) => {
    state.donationWidget.campaign = campaign
  },
  updatePledge: (state, pledge) => {
    state.donationWidget.pledge = pledge
    state.donationWidget.amount = pledge.amountDue
    state.donationWidget.enteredOtherAmount = pledge.amountDue
    state.donationWidget.firstName = pledge.first_name
    state.donationWidget.lastName = pledge.last_name
    state.donationWidget.email = pledge.email
    state.donationWidget.otherAmountInView = 'other'
  },
  updateDonationData: (state, data) => {
    state.donationWidget.hasDedication = data.hasDedication
    state.donationWidget.occurrence = data.occurrence
    state.donationWidget.otherAmountInView = data.otherAmountInView
    state.donationWidget.isAnonymous = data.isAnonymous
    state.donationWidget.inHonorOfSelection = data.inHonorOfSelection
    state.donationWidget.honoreeName = data.honoreeName
    state.donationWidget.honoreeEmail = data.honoreeEmail
    state.donationWidget.honoreeMessage = data.honoreeMessage
  },
  // Mutates in place — MakeDonationWidget caches the donationWidget
  // reference at created(), so replacing the object orphans that cache.
  // Campaign + pledge context comes from props bootstrapped once in
  // created() and must survive the reset; pledge prefill is re-applied
  // so reopening to fulfill a pledge isn't blank.
  resetDonationWidget: (state) => {
    const { campaign, campaignId, pledge, pledgeId } = state.donationWidget
    Object.assign(state.donationWidget, createInitialDonationWidgetState())
    state.donationWidget.campaign = campaign
    state.donationWidget.campaignId = campaignId
    state.donationWidget.pledgeId = pledgeId
    if (pledge) {
      state.donationWidget.pledge = pledge
      state.donationWidget.amount = pledge.amountDue
      state.donationWidget.enteredOtherAmount = pledge.amountDue
      state.donationWidget.firstName = pledge.first_name
      state.donationWidget.lastName = pledge.last_name
      state.donationWidget.email = pledge.email
      state.donationWidget.otherAmountInView = 'other'
    }
  },
}

const actions = {
  addCampaignId: ({commit}, payload) => {
    commit('addCampaignId', payload)
  },
    addPledgeId: ({commit}, payload) => {
      commit('addPledgeId', payload)
  },
  updateAmount: ({commit}, payload) => {
    commit('updateAmount', payload)
  },
  updateEnteredOtherAmount: ({commit}, payload) => {
    commit('updateEnteredOtherAmount', payload)
  },
  updateOtherAmountInView: ({commit}, payload) => {
    commit('updateOtherAmountInView', payload)
  },
  updateCampaign: ({commit}, payload) => {
    commit('updateCampaign', payload)
  },
  updatePledge: ({commit}, payload) => {
    commit('updatePledge', payload)
  },
  updateDonationData: ({commit}, payload) => {
    commit('updateDonationData', payload)
  },
  resetDonationWidget: ({commit}) => {
    commit('resetDonationWidget')
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
